import { useEffect } from 'react';
import { routeHistory } from '@nackle/biw-web-router';
import { useFeatureFlags } from '../../featureFlags';

/**
 * Route-level feature-flag guard. When `flag` is disabled, redirect to
 * `fallbackPath` and render nothing — so the wrapped page never mounts. Because
 * the child is only rendered when the flag is on, none of its hooks, effects,
 * URL-param writes or data fetches ever fire on a disabled route (no flash, no
 * stray `?tab=` param, no wasted request).
 *
 * Uses `replace` rather than `push` so the disabled URL does not leave a
 * back-button trap.
 */
export const FlagGuard = ( { flag, fallbackPath, children } ) => {
    const [ enabled ] = useFeatureFlags( [ flag ] );

    useEffect( () => {
        if ( !enabled ) {
            routeHistory.replace( fallbackPath );
        }
    }, [ enabled, fallbackPath ] );

    return enabled ? children : null;
};
